import { render } from "./ArtGalleryLoop.vue?vue&type=template&id=48547109"
import script from "./ArtGalleryLoop.vue?vue&type=script&lang=js"
export * from "./ArtGalleryLoop.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__